// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"440ad221","835":"30ffd099","917":"b45b2d16"}[chunkId] + ".chunk.js";
};